// polyfills.js
// This file manually sets up polyfills that are used throughout the application

// Import all polyfills at the top
import process from 'process';
import { Buffer } from 'buffer';

// Provide process for Axios
window.process = process;

// Provide Buffer for libraries that need it
window.Buffer = Buffer;

// Intercept all fetch requests to prevent hardcoded domain
const originalFetch = window.fetch;

// Override the global fetch function
window.fetch = function(url, options) {
  let interceptedUrl = url;
  
  // Intercept API requests for roastmylisting.ai and redirect them
  if (typeof url === 'string') {
    if (url.includes('roastmylisting.ai')) {
      // Simply remove the domain, keeping the path intact
      interceptedUrl = url.replace(/^https?:\/\/(?:www\.)?roastmylisting\.ai/, '');
      console.log(`Intercepted URL: ${url} → ${interceptedUrl}`);
    }
  }
  
  // Add additional debugging
  console.log(`Fetch request to: ${interceptedUrl}`);
  
  // Add timeout configuration to options
  const timeoutOptions = {
    ...options,
    signal: AbortSignal.timeout(300000) // 300 seconds timeout to match proxy settings
  };
  
  // Call the original fetch with our modified URL and timeout
  return originalFetch.call(this, interceptedUrl, timeoutOptions)
    .then(response => {
      // Log response status for debugging
      console.log(`Response from ${interceptedUrl}: ${response.status}`);
      return response;
    })
    .catch(error => {
      console.error(`Error fetching ${interceptedUrl}:`, error);
      throw error;
    });
};
